import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { CallBtn } from '../common/CallBtn';
import { Header } from './Header';
import { Footer } from './Footer';
import '../../styles/layout.css';

const GlobalStyles = styled.div`
  h2 {
    color: ${(props) => props.$h2Color};
  }
  h3 {
    color: ${(props) => props.$h3Color};
  }
  h4 {
    color: ${(props) => props.$h4Color};
  }
  h5 {
    color: ${(props) => props.$h5Color};
  }
  h6 {
    color: ${(props) => props.$h6Color};
  }
  a {
    color: ${(props) => props.$linkColor};
    font-weight: bold;
    transition: all 0.25s;
    &:hover {
      color: ${(props) => props.$linkColorHover};
      transition: all 0.25s;
    }
  }
`;

const Layout = (props) => {
  const { children, page, sanity } = props;
  const { colors } = sanity;
  return (
    <div id="layout">
      <Header page={page} sanity={sanity} {...props} />
      <GlobalStyles
        id="global-styles"
        $linkColor={colors?.accent?.default}
        $linkColorHover={colors?.accent?.light}
        $h2Color={colors?.primary?.dark}
        $h3Color={colors?.secondary?.dark}
        $h4Color={colors?.neutral?.dark}
        $h5Color={colors?.neutral?.default}
        $h6Color={colors?.neutral?.default}
      >
        <main id="main">{children}</main>
      </GlobalStyles>
      <Footer page={page} sanity={sanity} {...props} />
      <CallBtn sanity={sanity} page={page} />
    </div>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export { Layout };
